import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";
import { localServiceData } from "@/data/localServiceData";

const SmartHomeWestervoort = () => {
  return <LocalServiceTemplate data={localServiceData['smart-home-westervoort']} />;
};

export default SmartHomeWestervoort;